import useUploadCSVForm from '../../../hooks/useUploadCSVForm';
import Dropdown from "../../templates/Dropdown";

export default function CSVDropdown({ options }) {
  const {
    files, selectOption, isDropdownActive, toggleDropdown, closeDropdown, partialUpload, uploadError,
  } = useUploadCSVForm();

  return <Dropdown options={options} isDisabled={files?.length > 0 && !partialUpload && !uploadError} closeDropdown={closeDropdown} isDropdownActive={isDropdownActive} handleClick={toggleDropdown} selectOption={selectOption} />
}